import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ChannelService } from '../../shared/services/realtime-messaging/channel.service';

@Injectable()
export class BusinessTransactionRealtimeMessagingService implements OnDestroy {
    public finalizationResponse$: BehaviorSubject<any>;
    public completionResponse$: BehaviorSubject<any>;

    constructor(private channelService: ChannelService) {
        this.finalizationResponse$ = new BehaviorSubject<any>(null);
        this.completionResponse$ = new BehaviorSubject<any>(null);
        this.channelService.bindConnectionMessage('realtimehub', 'BusinessTransactionCompletionResponse', this.completionResponse);
        this.channelService.bindConnectionMessage('realtimehub', 'BusinessTransactionFinalizationResponse', this.finalizationResponse);
    }

    ngOnDestroy() {
        this.channelService.unbindConnectionMessage('realtimehub', 'BusinessTransactionCompletionResponse', this.completionResponse);
        this.channelService.unbindConnectionMessage('realtimehub', 'BusinessTransactionFinalizationResponse', this.finalizationResponse);
    }

    // callback method used to get data back from the api when the trasaction is finalized
    finalizationResponse = (data?) => {
        console.log('Received FINALIZATION response from SignalR', data);
        this.finalizationResponse$.next(data);

    };

    // RJM: 08312018: callback method used to get data back from the api when the trasaction is completed
    completionResponse = (data?) => {
        console.log('Received COMPLETION response from SignalR', data);
        this.completionResponse$.next(data);
    };
}
